<div mat-dialog-title>
  <h2>
    {{
    ( data && data.forFinalAssessment?'quiz.finalAssessmentResults':
    data.moduleId ? 'quiz.progress' : 'quiz.prePostAssessmentsResults')|translate
    }}
  </h2>
  <button type="button" class="close" mat-dialog-close aria-label="Close">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <ng-container *ngIf='!dataLoading'>
    <div class="mat-dialog-body" id="progressEleme" #dataToExport>
      <div class="table-responsive"
        *ngIf="finalAssessmentGraph && finalAssessmentGraph.slides && finalAssessmentGraph.slides.length">

        <table class="table table-assessment" [ngClass]="{'snapshot_elem':loadingExport}">
          <thead>
            <tr>
              <th>{{"quiz.modelAnswer"|translate}}</th>
              <th *ngFor="let record of finalAssessmentGraph.referenceCorrectAnswers">
                {{record.answer}}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="tdhead">{{"quiz.slideName"|translate}}</td>
              <td class="tdhead" *ngFor="let record of finalAssessmentGraph.slides"
                [attr.colspan]="record.questions && record.questions.length && record.questions.length > 1?record.questions.length:'1'">
                {{record.slideName}}
              </td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <ng-container *ngFor="let record of finalAssessmentGraph.slides">
                <td *ngFor="let question of record.questions">
                  {{question.questionId}}
                </td>
              </ng-container>
              <td></td>
            </tr>
            <tr *ngFor="let item of finalAssessmentGraph.traineeOverallScores">
              <td>{{item.key.name}}</td>
              <ng-container *ngFor="let record of finalAssessmentGraph.slides">
                <ng-container *ngFor="let question of record.questions">
                  <ng-container *ngFor="let traineeRecord of question.traineeResponses">
                    <ng-container *ngIf="item.key.userId == traineeRecord.trainee.userId">
                      <ng-container *ngIf="traineeRecord.answers && traineeRecord.answers.length">
                        <td *ngFor="let response of traineeRecord.answers"
                          [ngClass]="response.answer == 'C'? 'bg-correct': response.answer == 'PC'? 'bg-pcorrect' : 'bg-incorrect'">
                          <ng-container *ngIf="response.answer !== 'P'">
                            {{response.userAnswer}}
                          </ng-container>
                          <ng-container *ngIf="response.answer == 'P'">__</ng-container>
                        </td>
                      </ng-container>
                      <td *ngIf="!traineeRecord.answers || !traineeRecord.answers.length">__</td>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
              <td class="tdhead">
                {{item.value}}%
              </td>
            </tr>
            <tr>
              <td></td>
              <ng-container *ngFor="let record of finalAssessmentGraph.slides">
                <td class="tdhead" *ngFor="let question of record.questions">
                  {{question.correctPercentage}}%
                </td>
              </ng-container>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="table-responsive mb-3" *ngIf="traineeProgressDiagram && traineeProgressDiagram.length">

        <table class="table table-assessment" [ngClass]="{'snapshot_elem':loadingExport}">
          <tbody>
            <tr>
              <td class="tdhead"
                *ngIf="traineeProgressDiagram[0].assessmentType != finalAssessmentType.TraditionallyExam">Slide Name
              </td>
              <td class="tdhead">{{"quiz.question"|translate}}</td>
              <td class="tdhead">{{"quiz.chosenAnswer"|translate}}</td>
            </tr>
            <ng-container *ngFor="let record of traineeProgressDiagram">
              <tr *ngFor="let question of record.questionAndChossenAnswer; let i = index">
                <ng-container *ngIf="traineeProgressDiagram[0].assessmentType != finalAssessmentType.TraditionallyExam">
                  <td *ngIf="i == 0"
                    [attr.rowspan]="record.questionAndChossenAnswer && record.questionAndChossenAnswer.length && record.questionAndChossenAnswer.length > 1?record.questionAndChossenAnswer.length:'1'">
                    {{record.slideName}}
                  </td>
                </ng-container>
                <td>{{question.questionIndex}}</td>
                <td>
                  {{question.chossenAnswer}}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="table-responsive mb-3"
        *ngIf="finalAssessmentForTrainee && finalAssessmentForTrainee.slides && finalAssessmentForTrainee.slides.length">

        <table class="table table-assessment" [ngClass]="{'snapshot_elem':loadingExport}">
          <tbody>
            <tr>
              <td class="tdhead">{{"quiz.slideName"|translate}}</td>
              <td class="tdhead">{{"quiz.question"|translate}}</td>
              <td class="tdhead">{{"quiz.answer"|translate}}</td>
              <td class="tdhead">{{"quiz.questionScore"|translate}}</td>
              <td class="tdhead">{{"quiz.caseScore"|translate}}</td>
            </tr>
            <ng-container *ngFor="let record of finalAssessmentForTrainee.slides">
              <tr *ngFor="let question of record.questions; let i = index">

                <td *ngIf="i == 0"
                  [attr.rowspan]="record.questions && record.questions.length && record.questions.length > 1?record.questions.length:'1'">
                  {{record.slideName}}
                </td>
                <td>{{question.questionId}}</td>
                <ng-container *ngFor="let response of question.traineeResponses">
                  <td *ngFor="let item of response.answers">
                    <span class="badge-status"
                      [ngClass]="item.answer == 'C'? 'success': item.answer == 'PC'? 'warning' : 'danger'">
                      <mat-icon *ngIf="!loadingExport" class="mr-1">
                        {{item.answer == 'C' ? 'check_circle' : item.answer == 'PC' ? 'error'
                        :'cancel'}}
                      </mat-icon>
                      {{(item.answer == 'C' ? 'trainee.correct' : item.answer == 'PC' ? 'trainee.partialCorrect' :
                      'trainee.incorrect') | translate}}
                    </span>
                  </td>
                </ng-container>
                <td>
                  {{question.correctPercentage}}%
                </td>
                <td class="tdhead" *ngIf="i == 0"
                  [attr.rowspan]="record.questions && record.questions.length && record.questions.length > 1?record.questions.length:'1'">
                  {{record.scorePercentage}}%
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="table-responsive mb-3"
        *ngIf="traineePreAssessmentReportCard && traineePreAssessmentReportCard.slideReports && traineePreAssessmentReportCard.slideReports.length">

        <table class="table table-assessment" [ngClass]="{'snapshot_elem':loadingExport}">
          <tbody>
            <tr>
              <td class="tdhead">{{"quiz.preAssessment"|translate}}</td>
              <td class="tdhead">{{"quiz.question"|translate}}</td>
              <td class="tdhead">{{"quiz.answer"|translate}}</td>
              <td class="tdhead">{{"quiz.score"|translate}}</td>
            </tr>
            <ng-container *ngFor="let record of traineePreAssessmentReportCard.slideReports">
              <tr *ngFor="let question of record.questionReports; let i = index">

                <td *ngIf="i == 0"
                  [attr.rowspan]="record.questionReports && record.questionReports.length && record.questionReports.length > 1?record.questionReports.length:'1'">
                  {{record.slideName}}
                </td>
                <td>{{question.questionId}}</td>
                <td *ngFor="let response of question.traineeResponses">
                  {{response.value}}
                </td>
                <td>
                  <!-- <mat-icon
                    [ngClass]="question.correctness == 'C'? 'text-success': question.correctness == 'PC'? 'bg-pcorrect' :'text-danger'">
                    {{question.correctness == 'C' ? 'check_circle' : question.correctness == 'PC' ? 'error' :'cancel'}}
                  </mat-icon> -->
                  <span class="badge-status"
                    [ngClass]="question.correctness == 'C'? 'success': question.correctness == 'PC'? 'warning' : 'danger'">
                    <mat-icon *ngIf="!loadingExport" class="mr-1">
                      {{question.correctness == 'C' ? 'check_circle' : question.correctness == 'PC' ? 'error'
                      :'cancel'}}
                    </mat-icon>
                    {{(question.correctness == 'C' ? 'trainee.correct' : question.correctness == 'PC' ?
                    'trainee.partialCorrect'
                    : 'trainee.incorrect') | translate}}
                  </span>
                </td>
                <td class="tdhead" *ngIf="i == 0"
                  [attr.rowspan]="record.questionReports && record.questionReports.length && record.questionReports.length > 1?record.questionReports.length:'1'">
                  {{record.scorePercentage}}%
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="table-responsive mb-3"
        *ngIf="traineePostAssessmentReportCard && traineePostAssessmentReportCard.slideReports && traineePostAssessmentReportCard.slideReports.length">

        <table class="table table-assessment" [ngClass]="{'snapshot_elem':loadingExport}">
          <tbody>
            <tr>
              <td class="tdhead">{{"quiz.postAssessment"|translate}}</td>
              <td class="tdhead">{{"quiz.question"|translate}}</td>
              <td class="tdhead">{{"quiz.answer"|translate}}</td>
              <td class="tdhead">{{"quiz.score"|translate}}</td>
            </tr>
            <ng-container *ngFor="let record of traineePostAssessmentReportCard.slideReports">
              <tr *ngFor="let question of record.questionReports; let i = index">

                <td *ngIf="i == 0"
                  [attr.rowspan]="record.questionReports && record.questionReports.length && record.questionReports.length > 1?record.questionReports.length:'1'">
                  {{record.slideName}}
                </td>
                <td>{{question.questionId}}</td>
                <td *ngFor="let response of question.traineeResponses">
                  {{response.value}}
                </td>
                <td>
                  <!-- <mat-icon
                    [ngClass]="question.correctness == 'C'? 'text-success':question.correctness == 'PC'? 'bg-pcorrect' : 'text-danger'">
                    {{question.correctness == 'C' ? 'check_circle' : question.correctness == 'PC' ? 'error' :'cancel'}}
                  </mat-icon> -->
                  <span class="badge-status"
                    [ngClass]="question.correctness == 'C'? 'success': question.correctness == 'PC'? 'warning' : 'danger'">
                    <mat-icon *ngIf="!loadingExport" class="mr-1">
                      {{question.correctness == 'C' ? 'check_circle' : question.correctness == 'PC' ? 'error'
                      :'cancel'}}
                    </mat-icon>
                    {{(question.correctness == 'C' ? 'trainee.correct' : question.correctness == 'PC' ?
                    'trainee.partialCorrect'
                    : 'trainee.incorrect') | translate}}
                  </span>
                </td>
                <td class="tdhead" *ngIf="i == 0"
                  [attr.rowspan]="record.questionReports && record.questionReports.length && record.questionReports.length > 1?record.questionReports.length:'1'">
                  {{record.scorePercentage}}%
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="table-responsive mb-3"
        *ngIf="preAssessmentGraphOfData && preAssessmentGraphOfData.slides && preAssessmentGraphOfData.slides.length">

        <table class="table table-assessment" [ngClass]="{'snapshot_elem':loadingExport}">
          <tbody>
            <!-- <tr>
              <td class="tdhead">{{"quiz.preAssessment"|translate}}</td>
              <td class="tdhead"></td>
              <td class="tdhead" *ngFor="let record of preAssessmentGraphOfData.traineeOverallScores">
                {{record.key.name}}
              </td>
              <td class="tdhead">{{"quiz.questionScore"|translate}}</td>
              <td>{{"quiz.caseScore"|translate}}</td>
            </tr> -->
            <tr>
              <td class="tdhead">{{"quiz.preAssessment"|translate}}</td>
              <td class="tdhead" *ngFor="let record of preAssessmentGraphOfData.slides"
                [attr.colspan]="record.questions && record.questions.length && record.questions.length > 1?record.questions.length:'1'">
                {{record.slideName}}
              </td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <ng-container *ngFor="let record of preAssessmentGraphOfData.slides">
                <td *ngFor="let question of record.questions">
                  {{question.questionId}}
                </td>
              </ng-container>
              <td></td>
            </tr>
            <tr *ngFor="let item of preAssessmentGraphOfData.traineeOverallScores">
              <td>{{item.key.name}}</td>
              <ng-container *ngFor="let record of preAssessmentGraphOfData.slides">
                <ng-container *ngFor="let question of record.questions">
                  <ng-container *ngFor="let traineeRecord of question.traineeResponses">
                    <ng-container *ngIf="item.key.userId == traineeRecord.key.userId">
                      <td *ngIf="traineeRecord.value">
                        <!-- <mat-icon *ngIf="traineeRecord.value !== 'P'"
                            [ngClass]="traineeRecord.value == 'C'? 'text-success':traineeRecord.value == 'PC'? 'bg-pcorrect':'text-danger'">
                            {{traineeRecord.value == 'C' ? 'check_circle' : traineeRecord.value == 'PC' ? 'error' :'cancel'}}
                          </mat-icon> -->
                        <span *ngIf="traineeRecord.value !== 'P'" class="badge-status"
                          [ngClass]="traineeRecord.value == 'C'? 'success': traineeRecord.value == 'PC'? 'warning' : 'danger'">
                          <mat-icon *ngIf="!loadingExport" class="mr-1">
                            {{traineeRecord.value == 'C' ? 'check_circle' : traineeRecord.value == 'PC' ? 'error'
                            :'cancel'}}
                          </mat-icon>
                          {{(traineeRecord.value == 'C' ? 'trainee.correct' : traineeRecord.value == 'PC' ?
                          'trainee.partialCorrect' :
                          'trainee.incorrect') | translate}}
                        </span>
                        <ng-container *ngIf="traineeRecord.value == 'P'">__</ng-container>
                      </td>
                      <td *ngIf="!traineeRecord.value">__</td>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
              <td class="tdhead">
                {{item.value}}%
              </td>
            </tr>
            <tr>
              <td></td>
              <ng-container *ngFor="let record of preAssessmentGraphOfData.slides">
                <td class="tdhead" *ngFor="let question of record.questions">
                  {{question.correctPercentage}}%
                </td>
              </ng-container>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive mb-3"
        *ngIf="postAssessmentGraphOfData && postAssessmentGraphOfData.slides && postAssessmentGraphOfData.slides.length">

        <table class="table table-assessment" [ngClass]="{'snapshot_elem':loadingExport}">
          <tbody>
            <!-- <tr>
            <td class="tdhead">{{"quiz.preAssessment"|translate}}</td>
            <td class="tdhead"></td>
            <td class="tdhead" *ngFor="let record of postAssessmentGraphOfData.traineeOverallScores">
              {{record.key.name}}
            </td>
            <td class="tdhead">{{"quiz.questionScore"|translate}}</td>
            <td>{{"quiz.caseScore"|translate}}</td>
          </tr> -->
            <tr>
              <td class="tdhead">{{"quiz.postAssessment"|translate}}</td>
              <td class="tdhead" *ngFor="let record of postAssessmentGraphOfData.slides"
                [attr.colspan]="record.questions && record.questions.length && record.questions.length > 1?record.questions.length:'1'">
                {{record.slideName}}
              </td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <ng-container *ngFor="let record of postAssessmentGraphOfData.slides">
                <td *ngFor="let question of record.questions">
                  {{question.questionId}}
                </td>
              </ng-container>
              <td></td>
            </tr>
            <tr *ngFor="let item of postAssessmentGraphOfData.traineeOverallScores">
              <td>{{item.key.name}}</td>
              <ng-container *ngFor="let record of postAssessmentGraphOfData.slides">
                <ng-container *ngFor="let question of record.questions">
                  <ng-container *ngFor="let traineeRecord of question.traineeResponses">
                    <ng-container *ngIf="item.key.userId == traineeRecord.key.userId">
                      <td *ngIf="traineeRecord.value">
                        <!-- <mat-icon *ngIf="traineeRecord.value !== 'P'"
                          [ngClass]="traineeRecord.value == 'C'? 'text-success':traineeRecord.value == 'PC'? 'bg-pcorrect':'text-danger'">
                          {{traineeRecord.value == 'C' ? 'check_circle' : traineeRecord.value == 'PC' ? 'error' :'cancel'}}
                        </mat-icon> -->
                        <span *ngIf="traineeRecord.value !== 'P'" class="badge-status"
                          [ngClass]="traineeRecord.value == 'C'? 'success': traineeRecord.value == 'PC'? 'warning' : 'danger'">
                          <mat-icon *ngIf="!loadingExport" class="mr-1">
                            {{traineeRecord.value == 'C' ? 'check_circle' : traineeRecord.value == 'PC' ? 'error'
                            :'cancel'}}
                          </mat-icon>
                          {{(traineeRecord.value == 'C' ? 'trainee.correct' : traineeRecord.value == 'PC' ?
                          'trainee.partialCorrect' :
                          'trainee.incorrect') | translate}}
                        </span>
                        <ng-container *ngIf="traineeRecord.value == 'P'">__</ng-container>
                      </td>
                      <td *ngIf="!traineeRecord.value">__</td>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
              <td class="tdhead">
                {{item.value}}%
              </td>
            </tr>
            <tr>
              <td></td>
              <ng-container *ngFor="let record of postAssessmentGraphOfData.slides">
                <td class="tdhead" *ngFor="let question of record.questions">
                  {{question.correctPercentage}}%
                </td>
              </ng-container>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive mb-3" *ngIf="scoreChangesPerSlide && scoreChangesPerSlide.length">

        <table class="table table-assessment" [ngClass]="{'snapshot_elem':loadingExport}">
          <tbody>
            <tr>
              <td class="tdhead"></td>
              <td class="tdhead">{{"quiz.preAssessment"|translate}}</td>
              <td class="tdhead">{{"quiz.postAssessment"|translate}}</td>
              <td class="tdhead">{{"quiz.change"|translate}}%</td>
            </tr>
            <tr *ngFor="let record of scoreChangesPerSlide; let i = index">
              <td class="w-25">{{record.slideName}}</td>
              <td class="w-25">
                {{record.preScore}}%
              </td>
              <td class="w-25">
                {{record.postScore}}%
              </td>
              <td class="w-25">
                {{record.changePercentage}}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive mb-3" *ngIf="traineeScoreChanges && traineeScoreChanges.length">
        <table class="table table-assessment" [ngClass]="{'snapshot_elem':loadingExport}">
          <tbody>
            <tr>
              <td class="tdhead"></td>
              <td class="tdhead">{{"quiz.preAssessment"|translate}}</td>
              <td class="tdhead">{{"quiz.postAssessment"|translate}}</td>
              <td class="tdhead">{{"quiz.change"|translate}}%</td>
            </tr>
            <tr *ngFor="let record of traineeScoreChanges; let i = index">
              <td class="w-25">{{record.traineeName}}</td>
              <td class="w-25">
                {{record.preScore}}%
              </td>
              <td class="w-25">
                {{record.postScore}}%
              </td>
              <td class="w-25">
                {{record.changePercentage}}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <app-chart-statistic [values]="chart.values" [title]="chart.title" [class]="chart.colums +' d-block mb-5'"
          [showYAxis]="chart.showYAxis ?? false" [legend]="chart.showLegend ?? false" [xAxisLabel]="chart.xAxisLabel!"
          [type]="chart.type!" [isDoughnut]="chart.isDoughnut!" [yAxisLabel]="chart.yAxisLabel!"
          [colorScheme]="chart.colorScheme" [key]="chart.key!" *ngFor="let chart of charts">
        </app-chart-statistic>
      </div>
      <button mat-icon-button (click)="printPage()" [hidden]="loadingExport" [disabled]="loadingExport"
        [class.loading]='loadingExport'>
        <svg xmlns="http://www.w3.org/2000/svg" id="Print_btn" data-name="Print btn" width="48" height="48"
          viewBox="0 0 48 48">
          <g id="BG" fill="#f7f1f9" stroke="#eadfef" stroke-width="1">
            <rect width="48" height="48" rx="23" stroke="none" />
            <rect x="0.5" y="0.5" width="47" height="47" rx="22.5" fill="none" />
          </g>
          <g id="print_black_24dp" transform="translate(12 12)">
            <path id="Path_19886" data-name="Path 19886" d="M0,0H24V24H0Z" fill="none" />
            <path id="Path_19887" data-name="Path 19887"
              d="M19,8H5a3,3,0,0,0-3,3v4a2.006,2.006,0,0,0,2,2H6v2a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2V17h2a2.006,2.006,0,0,0,2-2V11A3,3,0,0,0,19,8ZM15,19H9a1,1,0,0,1-1-1V14h8v4A1,1,0,0,1,15,19Zm4-7a1,1,0,1,1,1-1A1,1,0,0,1,19,12ZM17,3H7A1,1,0,0,0,6,4V6A1,1,0,0,0,7,7H17a1,1,0,0,0,1-1V4A1,1,0,0,0,17,3Z"
              fill="#469595" />
          </g>
        </svg>
      </button>
    </div>
  </ng-container>
</mat-dialog-content>